import { Component, OnInit, Input } from "@angular/core";

@Component({
    selector: "dodo-textarea",
    templateUrl: "./textarea.component.html",
    styleUrls: ["./textarea.component.scss"],
    standalone: false
})
export class TextareaComponent implements OnInit {
	@Input() settings;

	constructor() {}

	ngOnInit() {}
}
